module.exports = __webpack_public_path__ + "static/img/SmileAnimation_tripleberry.4e9d1fd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_tripleberry.gif
// module id = H4yb
// module chunks = 0